export const constants = {
  RESPONSIVE_SIZES: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "full", "max"],
  SIZE_VALUES: {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
    "2xl": 5,
    "3xl": 6,
    "4xl": 7,
    "5xl": 8,
    "6xl": 9,
    full: 10,
    max: 11
  }
};